module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile"
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [(_vm.isEnvironmentPc()) ? [_c('div', {
    staticClass: "toparea-text"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelectAnswer),
      expression: "showSelectAnswer"
    }],
    staticClass: "flexstretch"
  }, _vm._l((_vm.selectAnswers), function(text, key) {
    return _c('div', {
      key: key,
      staticClass: "item w200",
      class: [_vm.getTextFontSize(text), {
        'active': _vm.activeCorrectAnswer(text)
      }],
      on: {
        "click": function($event) {
          return _vm.checkAnswer(text)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(text))
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cards-container active-type3"
  }, _vm._l((_vm.actGroupIndexList), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "card-voice card-inner",
      class: _vm.templateType(groupIndex)
    }, [_vm._l((group), function(actIndex) {
      return [_c('div', {
        key: actIndex,
        staticClass: "item",
        class: {
          active: _vm.isActActive(actIndex),
          disabled: _vm.isActDisabled(actIndex)
        },
        on: {
          "click": function($event) {
            return _vm.audioReplay(actIndex)
          }
        }
      }, [_c('div', {
        staticClass: "select",
        class: [_vm.getTextFontSize(_vm.actList[actIndex].basicTextDeleteTag)]
      }, [
        [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.dispJapaneseStatus),
            expression: "dispJapaneseStatus"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].japaneseText)
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showQuestionText(actIndex)),
            expression: "showQuestionText(actIndex)"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].questionText)
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showAnswerText(actIndex)),
            expression: "showAnswerText(actIndex)"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].answerText)
          }
        })]
      ], 2), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [(_vm.isShowCorrectImg(actIndex) || _vm.isShowIncorrectImg(actIndex)) ? _c('div', {
        class: {
          correct: _vm.isShowCorrectImg(actIndex),
          incorrect: _vm.isShowIncorrectImg(actIndex)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "image"
      }, [_c('img', {
        attrs: {
          "src": _vm.actList[actIndex].image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        attrs: {
          "disabled": _vm.disableReplayButton(actIndex)
        },
        on: {
          "click": function($event) {
            return _vm.audioReplay(actIndex)
          }
        }
      })])])]
    })], 2)
  }), 0)] : [_c('div', {
    staticClass: "toparea-text"
  }, [_c('div', {
    staticClass: "flexstretch",
    style: ({
      visibility: _vm.showSelectAnswer ? 'visible' : 'hidden'
    })
  }, _vm._l((_vm.selectAnswers), function(text, key) {
    return _c('div', {
      key: key,
      staticClass: "item w200",
      class: {
        'active': _vm.activeCorrectAnswer(text)
      },
      on: {
        "click": function($event) {
          return _vm.checkAnswer(text)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(text)
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cards-container swiper-container swiper-container1 active-type3"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.actGroupIndexList), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "card-inner card-voice swiper-slide",
      class: _vm.templateType(groupIndex)
    }, [_c('div', {
      staticClass: "swiper-container swiper-container2"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, _vm._l((group), function(actIndex) {
      return _c('div', {
        key: actIndex,
        staticClass: "item swiper-slide",
        class: {
          active: _vm.isActActive(actIndex),
          disabled: _vm.isActDisabled(actIndex)
        },
        on: {
          "click": function($event) {
            return _vm.audioReplay(actIndex)
          }
        }
      }, [_c('div', {
        staticClass: "select"
      }, [
        [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.dispJapaneseStatus),
            expression: "dispJapaneseStatus"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].japaneseText)
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showQuestionText(actIndex)),
            expression: "showQuestionText(actIndex)"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].questionText)
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showAnswerText(actIndex)),
            expression: "showAnswerText(actIndex)"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.actList[actIndex].answerText)
          }
        })]
      ], 2), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [(_vm.isShowCorrectImg(actIndex) || _vm.isShowIncorrectImg(actIndex)) ? _c('div', {
        class: {
          correct: _vm.isShowCorrectImg(actIndex),
          incorrect: _vm.isShowIncorrectImg(actIndex)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "image",
        on: {
          "touchstart": function($event) {
            return _vm.onTouchStart(_vm.actList[actIndex].image)
          },
          "touchend": function($event) {
            return _vm.onTouchEnd()
          },
          "touchmove": function($event) {
            return _vm.onTouchEnd()
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.actList[actIndex].image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        attrs: {
          "disabled": _vm.disableReplayButton(actIndex)
        },
        on: {
          "click": function($event) {
            return _vm.audioReplay(actIndex)
          }
        }
      })])])
    }), 0)])])
  }), 0)])]], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0140a8d7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-0140a8d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/Tile.vue
// module id = 604
// module chunks = 1